import {
  PaymentAPI,
  PaymentError,
  PaymentMethodStripeSourceTypeMapping,
  PaymentMethodType,
  PaymentProvider,
  PaymentResponse,
  ProcessPaymentOptions,
} from '../../typings/Payment'
import { getGoogleSearchParam } from '../../lib/get-google-search-param'
import pollPayment from './poll-payment'

const handleSourcePayment = async (
  paymentProvider: PaymentProvider,
  paymentAPI: PaymentAPI,
  { orderId, selectedPaymentMethod, user, payment: { paymentIntent } }: ProcessPaymentOptions,
  lastPaymentAttempt: Date,
): Promise<PaymentResponse> => {
  if (!paymentIntent) {
    throw new Error('Payment intent was not correctly defined')
  }

  const fullName = `${user.firstName} ${user.lastName}`

  const returnUrl = new URL(
    `${window.location.href}&paymentInProgress=true&lastPaymentAttempt=${lastPaymentAttempt.getTime()}`,
  )

  const trackingParam = getGoogleSearchParam()

  if (trackingParam) {
    const [trackingName, trackingValue] = trackingParam.split('=')
    returnUrl.searchParams.append(trackingName, trackingValue)
  }

  const { error, source } = await paymentProvider.stripe!.createSource({
    type: PaymentMethodStripeSourceTypeMapping[selectedPaymentMethod.type! as PaymentMethodType],
    owner: {
      name: fullName,
      email: user.email,
    },
    metadata: {
      paymentIntent: paymentIntent.id,
    },
    amount: paymentIntent.amount,
    currency: paymentIntent.currency,
    redirect: {
      return_url: returnUrl.toString(),
    },
  })

  if (error) {
    return { wasSuccessful: false, error: error.message }
  }

  if (!source) {
    return { wasSuccessful: false, error: PaymentError.PAYMENT_ERROR_STRIPE_SOURCE }
  }

  // @ts-ignore 'flow' doesn't seem to exist in the source typing?
  const { flow, redirect, status } = source

  if (redirect && status === 'pending' && flow === 'redirect') {
    window.location.assign(redirect.url)

    // As window.location does the redirect in a non blocking way we do not
    // resolve this Promise and keep the UI in a loading state
    // eslint-disable-next-line promise/param-names
    return new Promise((_resolve, _reject) => {})
  }
  return pollPayment(paymentAPI, { orderId, lastPaymentAttempt })
}

export default handleSourcePayment
